import { render, staticRenderFns } from "./PatientStory.vue?vue&type=template&id=3c64f252"
import script from "./PatientStory.vue?vue&type=script&lang=js"
export * from "./PatientStory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports